(function () {
  'use strict';

  var COPY_RESET_MS = 2000;

  function copyText(text) {
    if (!text) return Promise.reject(new Error('empty'));

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (ok) resolve();
        else reject(new Error('copy failed'));
      } catch (err) {
        document.body.removeChild(textarea);
        reject(err);
      }
    });
  }

  function setCopiedState(button) {
    var label = button.querySelector('[data-rabitat-pdp-discount-copy-label]');
    var previous = label ? label.textContent : button.textContent;

    button.classList.add('is-copied');
    if (label) label.textContent = 'Copied!';
    else button.textContent = 'Copied!';

    window.setTimeout(function () {
      button.classList.remove('is-copied');
      if (label) label.textContent = previous;
      else button.textContent = previous;
    }, COPY_RESET_MS);
  }

  function onCopyClick(event) {
    var button = event.target.closest('[data-rabitat-pdp-discount-copy]');
    if (!button) return;

    var code =
      button.getAttribute('data-copy-target') ||
      (button.closest('[data-rabitat-pdp-additional-discount]') &&
        button.closest('[data-rabitat-pdp-additional-discount]').querySelector('[data-rabitat-pdp-discount-code]') &&
        button.closest('[data-rabitat-pdp-additional-discount]').querySelector('[data-rabitat-pdp-discount-code]').textContent);

    if (!code) return;

    copyText(code.trim())
      .then(function () {
        setCopiedState(button);
      })
      .catch(function () {
        /* silent fail */
      });
  }

  function init() {
    if (document.body.dataset.rabitatPdpDiscountCopyBound === 'true') return;
    document.body.dataset.rabitatPdpDiscountCopyBound = 'true';
    document.addEventListener('click', onCopyClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
